// libraries
import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import { List, Tag, Typography } from 'antd';
import { ArrowRightOutlined, CheckOutlined } from '@ant-design/icons';

// locales
import { txt } from '../../../../locales/i18n';
import { formatDate } from '../../../../utils/date';

export function ActivityListContentMobile(props: any): JSX.Element {
	const navigateTimeout = useRef<NodeJS.Timeout | null>(null);

	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		if (navigateTimeout.current !== null) clearTimeout(navigateTimeout.current);

		const itemId = location.hash.replace('#', '');
		const itemSelector = `li#item-${itemId}`;
		const listItemElement = document.querySelector(itemSelector);

		if (listItemElement === null) return;

		navigateTimeout.current = setTimeout(() => {
			listItemElement.scrollIntoView({ behavior: 'auto', block: 'center' });
		}, 100);
	}, [props.dataSource, location.hash]);

	function renderDurationDates(dates: any[] | null): JSX.Element {
		if (dates === null || dates.length !== 1) {
			return <Tag color="blue">{txt('global.recurring')}</Tag>;
		}

		const format: string = 'DD/MM-YY HH:mm';
		const { start_date, end_date } = dates[0];

		return (
			<>
				<span>{moment(start_date).format(format)}</span>
				<ArrowRightOutlined style={{ marginInline: '0.4rem' }} />
				<span>{moment(end_date).format(format)}</span>
			</>
		);
	}

	function renderItem(item: Record<string, any>): JSX.Element {
		return (
			<List.Item
				id={'item-' + item.id}
				onClick={() => {
					history.replace({ hash: String(item.id), search: location.search });
					history.push(`/activities/${item.id}`);
				}}
			>
				<StyledListItemContainer>
					<Typography.Text type="secondary">{txt('global.title')}</Typography.Text>
					<Typography.Text ellipsis>{item.activityTitle}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.duration')}</Typography.Text>
					<Typography.Text ellipsis>{renderDurationDates(item.dates)}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.username')}</Typography.Text>
					<Typography.Text ellipsis>{item.username}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.municipality')}</Typography.Text>
					<Typography.Text ellipsis>{item.municipalityName}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.universe')}</Typography.Text>
					<Typography.Text ellipsis>{item.universeTitle}</Typography.Text>

					<Typography.Text type="secondary">Status</Typography.Text>
					<Typography.Text ellipsis>
						{item.approved ? <CheckOutlined /> : null}
					</Typography.Text>

					<Typography.Text type="secondary">{txt('global.created')}</Typography.Text>
					<Typography.Text ellipsis>{formatDate(item.created)}</Typography.Text>

					<Typography.Text type="secondary">Crawler</Typography.Text>
					<Typography.Text ellipsis>
						{item.crawler && <Tag color="blue">{item.crawler}</Tag>}
					</Typography.Text>
				</StyledListItemContainer>
			</List.Item>
		);
	}

	return (
		<List
			size="large"
			itemLayout="vertical"
			loading={props.loading}
			renderItem={renderItem}
			dataSource={props.dataSource}
		/>
	);
}

const StyledListItemContainer = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 0ch 1ch;
`;
